import { gql } from '@apollo/client'

export const CREATE_OR_UPDATE_DRAFT_SCORE_GRID = gql`
  mutation CreateOrUpdateDraftScoreGrid(
    $companyId: HashedId!
    $country: Country!
    $employeeId: HashedId!
    $draftScoreGridInput: DraftScoreGridInput!
  ) {
    createOrUpdateDraftScoreGrid(
      companyId: $companyId
      country: $country
      employeeId: $employeeId
      draftScoreGridInput: $draftScoreGridInput
    )
  }
`

export const IMPORT_EXCEL = gql`
  mutation ImportScoreGrids($companyId: HashedId!, $buIds: [HashedId!]!, $country: Country!, $excelData: [ScoreGridExcelDataInput!]!) {
    importScoreGrids(companyId: $companyId, buIds: $buIds, country: $country, excelData: $excelData)
  }
`
